import { price } from '@/lib/format';
import { cn } from '@/lib/cn';

interface PriceTextProps {
  /** NUMERIC 컬럼이 string 으로 전달될 수도 있어 string 까지 허용 */
  value: number | string | null | undefined;
  currency?: string;
  trend?: 'up' | 'down' | 'flat';
  className?: string;
}

export function PriceText({ value, currency = '원', trend, className }: PriceTextProps) {
  const color =
    trend === 'up'
      ? 'text-[var(--color-rise)]'
      : trend === 'down'
      ? 'text-[var(--color-fall)]'
      : '';
  return (
    <span className={cn('num', color, className)}>{price(value, currency)}</span>
  );
}
